// @todo: Translations

const SOLR_SEARCH_REST_CONFIG_NEWS = {
  endpoint: `/api/search/news`,
  pageMode: "endless", // endless or pager or none
  search: false,
  fields: [],
  facets: [
    {
      id: "news_published_year",
      label: "Year",
      type: "scroll_to",
    }
  ],
  presetFilters: [],
  pagerSize: 9,
};

export default SOLR_SEARCH_REST_CONFIG_NEWS;
